import React from 'react'

export const UpdateEventPage = () => {
  return (
    <div>UpdateEventPage</div>
  )
}
